import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React__default__default, { useMemo } from 'react';
import PropTypes__default from 'prop-types';
import styles from '../../node_modules/@flixbus/honeycomb/dist/scss/components/pager.scss.js';
import HoneyBem from '../../packages/honey-bem/honey-bem.js';
import ReactUtils from '../../packages/react-utils/react-utils.js';
import { PAGER_ELEMS, PAGER_DEFAULT_ELEM } from './types.js';
import { PagerContext } from './pager-context.js';
import { Injecss } from '../../packages/injecss/injecss.js';

var bem = HoneyBem.init('pager', styles);
var Pager = function (_a) {
  var children = _a.children,
    extraClasses = _a.extraClasses,
    ariaLabel = _a["aria-label"],
    _b = _a.contentFit,
    contentFit = _b === void 0 ? false : _b,
    _c = _a.Elem,
    Elem = _c === void 0 ? PAGER_DEFAULT_ELEM : _c,
    rest = __rest(_a, ["children", "extraClasses", 'aria-label', "contentFit", "Elem"]);
  var arrows = ReactUtils.getChildrenByName(children, 'PagerArrow');
  var items = ReactUtils.getChildrenByName(children, 'PagerItem');
  var prevArrow = arrows.find(function (arrow) {
    return arrow.props.side === 'prev';
  });
  var nextArrow = arrows.find(function (arrow) {
    return arrow.props.side === 'next';
  });
  var pagerState = useMemo(function () {
    return {
      PagerElem: Elem
    };
  }, [Elem]);
  return /*#__PURE__*/React__default__default.createElement(PagerContext.Provider, {
    value: pagerState
  }, /*#__PURE__*/React__default__default.createElement("nav", __assign({
    "aria-label": ariaLabel,
    className: bem.b({
      'content-fit': contentFit
    }, extraClasses)
  }, rest), /*#__PURE__*/React__default__default.createElement("ul", {
    className: bem.e('list')
  }, prevArrow, items, nextArrow)));
};
Pager.displayName = 'Pager';
Pager.propTypes = {
  'aria-label': PropTypes__default.string.isRequired,
  Elem: PropTypes__default.oneOf(PAGER_ELEMS),
  children: PropTypes__default.node,
  extraClasses: PropTypes__default.string,
  contentFit: PropTypes__default.bool
};
var pager = Injecss(Pager, styles);

export { Pager, pager as default };
